// Public-facing entry for anonymous visitors. Keeps the surface deliberately
// anodyne — title, tagline, form. Nothing about what the app actually does,
// no preview of registered recipes, no API hints, no errors leaking which
// usernames exist.

import { useState } from "react";
import { useAuth } from "./auth";

export function Login() {
  const { login } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await login(username.trim(), password);
    } catch (e) {
      setError(String(e instanceof Error ? e.message : e));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="public-shell">
      <div className="public-card">
        <div className="public-brand">recipe-runtime</div>
        <div className="public-tagline">Sign in to continue.</div>

        <form onSubmit={submit} style={{ marginTop: 24 }}>
          <div>
            <label>Username</label>
            <input
              type="text"
              autoComplete="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoFocus
            />
          </div>
          <div style={{ marginTop: 12 }}>
            <label>Password</label>
            <input
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          {error && (
            <div className="status-error" style={{ marginTop: 12 }}>
              {error}
            </div>
          )}
          <div style={{ marginTop: 20 }}>
            <button
              type="submit"
              disabled={busy || !username.trim() || !password}
              style={{ width: "100%" }}
            >
              {busy ? "Signing in…" : "Sign in"}
            </button>
          </div>
        </form>

        <div className="public-footer">
          Access is invitation-only. Contact the administrator for an account.
        </div>
      </div>
    </div>
  );
}
